
export interface ImageFileData {
  file: File;
  compression?: CompressionResult;
  backgroundRemoval?: BackgroundRemovalResult;
  isCompressing: boolean;
  isRemovingBackground: boolean;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  retryCount: number;
  error?: string;
}

export interface CompressionResult {
  compressedFile: File;
  compressedUrl: string;
  originalSize: number;
  compressedSize: number;
  compressionRatio: number;
}

export interface BackgroundRemovalResult {
  processedFile: File;
  processedUrl: string;
  originalSize: number;
  processedSize: number;
}

export const MAX_FILES_FREE = 10;
export const MAX_FILES_PREMIUM = -1; // -1 indicates unlimited
export const MAX_RETRY_ATTEMPTS = 3;
